import React, { FC, ReactNode } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { DocumentsState } from '../../../../../interfaces/DocumentsState';
import { DocumentGroup } from '../../../../../interfaces/DocumentGroup';
import GroupedContract from './GroupedContract';

export interface GroupedContractsProps {
  group: DocumentGroup;
  children?: ReactNode;
}

const GroupedContracts: FC<GroupedContractsProps> = ({ group }) => {
  const groups = useScopedSelector((state: DocumentsState) => state.groups);
  return (
    <>
      {group.documents?.map((document) => (
        <GroupedContract groups={groups} document={document} key={document.id} />
      ))}
    </>
  );
};

export default GroupedContracts;
